import { cva } from '@/styled-system/css';

export const labelRecipe = cva({
  base: {
    color: {
      base: 'text.neutral',
      _hover: 'text.neutral',
    },
    _notDisabled: {
      cursor: 'pointer',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    required: {
      true: {
        _after: {
          content: '"*" / ""',
          color: 'Label.indicator.required',
          marginInlineStart: 'micro.default',
        },
      },
      false: {},
    },
    optional: {
      true: {
        _after: {
          content: '"(optional)"',
          color: 'text.subtle',
          fontWeight: '{normal}',
          marginInlineStart: 'micro.default',
        },
      },
      false: {},
    },
    size: {
      md: {
        textStyle: 'body-sm-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
});
